"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Semua Kursus",
    "className": "Nama Lokakarya",
    "continue": "Lanjutkan",
    "courseChapter": "Bab",
    "courseEvaluate": "Evaluasi",
    "courseHours": "Kredit",
    "courseInfo": "Perincian",
    "courseNote": "Catatan",
    "coursesCategory": "Kategori Kursus",
    "electiveCourses": "Kursus Pilihan",
    "pages": "Halaman",
    "relatedCourses": "Kursus yang relevan",
    "requiredCourses": "Perkuliahan",
    "searchTips": "Harap Masukkan Nama Kursus",
    "studentsNum": "Audiens",
    "teachersDesc": "Guru",
    "newCourse": "Kursus terbaru"
  },
  "footer_zlb": {
    "aboutUs": "Tentang Kami",
    "downLoad": "Unduh aplikasi",
    "qr": "Kode QR"
  },
  "global_zlb": {
    "am": "AM",
    "isa": "　",
    "night": "Malam",
    "pm": "PM"
  },
  "header_zlb": {
    "accoutPw": "Kata Sandi Akun",
    "curDis": "Sedang berlangsung",
    "curUser": "Pengguna Saat Ini",
    "edit": "Perbarui",
    "helpCenter": "Pusat Bantuan",
    "hisDis": "Riwayat",
    "index": "Beranda",
    "joinStore": "Tambahkan ke favorit",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Pesan",
    "setIndex": "Tetapkan sebagai halaman beranda",
    "userImg": "Foto Profil"
  },
  "index_zlb": {
    "discuss": "Lokakarya",
    "find": "Temukan",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Saya"
  },
  "info_zlb": {
    "admin": "Administrator",
    "hasAgenda": "Anda telah bergabung dengan Agenda.",
    "noDown": "Tidak ada lampiran untuk diunduh!",
    "pleaseInp": "Silakan Masuk",
    "submit": "Berhasil dikirim!",
    "withinTime": "Tugas belum dimulai",
    "noSubmitWork": "Tugas tidak dikirim"
  },
  "login_zlb": {
    "accountLogin": "Masuk",
    "accountNotEmpty": "Akun harus diisi",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Batal",
    "captchaNotEmpty": "Kode verifikasi harus diisi",
    "captchaTips": "Kode verifikasi salah",
    "changeEmail": "Perbarui Email",
    "changeEmailSuccess": "Alamat email berhasil diperbarui.",
    "changeEmailSuccessTips": "Anda telah berhasil memperbarui email.",
    "Confirm": "Konfirmasi",
    "currentEmail": "Email Saat ini",
    "emailCaptcha": "Kode verifikasi email",
    "emailCaptchaEmpty": "Kode verifikasi email tidak boleh kosong",
    "encryEmail": "Email keamanan",
    "error": "Galat kode verifikasi",
    "forget": "Lupa kata sandi",
    "formerEamil": "Email Asli",
    "incorrectTips": "Galat input nama pengguna atau kata sandi",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Email Baru",
    "newEmailBinded": "Email baru ditautkan ke akun pengguna Anda",
    "newEmailEmpty": "Email baru tidak boleh kosong",
    "newEmailFomat": "Format email baru salah",
    "newEmailSupport": "Alamat email lama dan baru tidak cocok",
    "prevStep": "Langkah terakhir",
    "nextStep": "Langkah Berikutnya",
    "reset": "Reset",
    "loginNow": "Masuk sekarang",
    "resetSuccess": "Reset berhasil",
    "resetSuccessTips": "Anda telah berhasil mereset kata sandi Anda. Silakan lanjut untuk masuk",
    "msgCaptcha": "Kode Verifikasi SMS",
    "getCaptcha": "Dapatkan kode verifikasi",
    "resetPassword": "Reset kata sandi",
    "loginFail": "Masuk gagal, coba lagi!",
    "failTips": "Verifikasi Gagal",
    "inputUserName": "Nama pengguna",
    "goHome": "Ke beranda",
    "passwordFormat": "Kata sandi harus terdiri dari 8-32 digit dan mengandung angka serta huruf besar dan kecil.",
    "surePasswordEmpty": "Konfirmasi Kata Sandi tidak boleh kosong",
    "confirmNot": "Kata sandi dan kata sandi konfirmasi tidak konsisten",
    "changePasswordSuccess": "Kata sandi berhasil diperbarui",
    "continueLogin": "Masuk lagi",
    "orError": "Nama pengguna atau kata sandi salah.",
    "orgEmailEmpty": "Email asli tidak boleh kosong",
    "orgEmailFormat": "Format email asli salah",
    "orgEmailNot": "Alamat email asli salah",
    "passWord": "Kata sandi",
    "surePassword": "Konfirmasi Kata Sandi",
    "passwordBits": "Kata sandi setidaknya harus terdiri dari 6 karakter",
    "passwordNotEmpty": "Kata sandi harus diisi",
    "pWord": "Kata sandi",
    "sign": "Masuk",
    "uName": "Akun",
    "userName": "Nama pengguna",
    "validate": "Kode Verifikasi",
    "verification": "Silakan selesaikan verifikasi di bawah ini",
    "appdownload": "Unduh aplikasi",
    "scancode": "Pindai kode QR untuk mengunduh",
    "poor": "Lemah",
    "middle": "Sedang",
    "strong": "Kuat"
  },
  "login": {
    "logout": "Keluar dengan sukses",
    "resetLoginTips": "Anda telah berhasil mengubah kata sandi, Anda harus masuk lagi, dan keluar secara otomatis setelah 3 detik",
    "sure": "Konfirmasi",
    "cancel": "Batal",
    "captchaNotEmpty": "Kode verifikasi harus diisi",
    "accountNotEmpty": "Akun harus diisi",
    "passwordNotEmpty": "Kata sandi harus diisi",
    "inputCaptcha": "Kode Verifikasi",
    "getCaptcha": "Dapatkan kode verifikasi",
    "inputOrigPassword": "Silakan masukkan kata sandi sebelumnya",
    "inputNewPassowrd": "Silakan masukkan kata sandi baru",
    "confimPassword": "Konfirmasi Kata Sandi",
    "changePassword": "Ganti Kata Sandi",
    "nextStep": "Langkah Berikutnya",
    "resetPassword": "Reset kata sandi",
    "resetDone": "Reset kata sandi berhasil",
    "msgCaptcha": "Kode verifikasi email"
  },
  "look_zlb": {
    "aboutLecturer": "Kursus yang relevan",
    "benginLearn": "Mulai Belajar",
    "chapter": "Bab",
    "delete": "Hapus",
    "details": "Perincian",
    "download": "Unduh",
    "dynamic": "Berita",
    "evaluation": "Evaluasi",
    "hotDyc": "Tren",
    "lecture": "Buka Kursus",
    "lecturer": "Guru",
    "lectureTest": "Kategori Kursus",
    "look": "Temukan",
    "lookAll": "Lihat Semua",
    "note": "Catatan",
    "score": "Skor"
  },
  "myMessage_zlb": {
    "passwordError": "Galat input kata sandi sebelumnya",
    "aboutUs": "Tentang Kami",
    "allcourse": "Semua Kursus",
    "atypism": "Dua kata sandi tidak cocok",
    "birth": "Tanggal lahir",
    "cancel": "Batal",
    "carryOut": "Lengkap",
    "changePassword": "Ganti Kata Sandi",
    "chineseName": "Nama Tionghoa",
    "chineseNamePlaceholder": "Silakan masukkan nama Tionghoa",
    "code": "Kode Verifikasi",
    "codeError": "Galat kode verifikasi",
    "comment": "Komentar",
    "complete": "Lengkap",
    "completeUserInfo": "Silakan lengkapi informasi pribadi",
    "confirm": "Konfirmasi Kata Sandi",
    "continueStudy": "Lanjutkan",
    "country": "Negara",
    "countryName": "Nama",
    "countryNamePlaceholder": "Silakan masukkan nama Anda.",
    "countryPlaceholder": "Pilihlah satu negara",
    "courseLearned": "Selesai",
    "delete": "Hapus",
    "documentType": "Jenis ID Dokumen",
    "downloaded": "Diunduh",
    "downloading": "Mengunduh",
    "eduLevel": "Tingkat Pendidikan",
    "eduLevelPlaceholder": "Silakan pilih tingkat pendidikan",
    "email": "Email",
    "emailCode": "Kode verifikasi email",
    "gender": "Jenis Kelamin",
    "genderPlaceholder": "Silakan pilih jenis kelamin Anda",
    "getCode": "Dapatkan kode verifikasi email",
    "hasSent": "Dikirim",
    "helpCenter": "Pusat Bantuan",
    "hour": "Jam",
    "improveInformation": "Silakan lengkapi informasi pribadi Anda",
    "joinClasses": "Kursus yang dihadiri",
    "joinDis": "Lokakarya yang dihadiri",
    "learned": "Selesai",
    "learning": "Sedang berlangsung ",
    "lecture": "Kursus",
    "mailbox": "Email",
    "mailboxValidate": "Verifikasi email gagal",
    "man": "Laki-Laki",
    "management": "Pengaturan",
    "minutes": "x jam x menit",
    "modify": "Perbarui",
    "modifyEmail": "Perbarui Email",
    "my": "Saya sendiri",
    "myCertificate": "Sertifikat Saya",
    "mycourse": "Kursus Saya",
    "myDownload": "Unduhan saya",
    "myLecture": "Kursus Saya",
    "myNotes": "Catatan Saya",
    "newMail": "Email Baru",
    "newPassword": "Kata Sandi Baru",
    "nextStep": "Langkah Berikutnya",
    "orError": "Nama pengguna atau kata sandi salah.",
    "origin": "Dari",
    "originalPassword": "Kata Sandi Sebelumnya",
    "password": "Kata sandi",
    "phone": "Nomor Telepon",
    "pleChoose": "Silakan pilih tanggal lahir",
    "post": "Kirim",
    "postPlaceholder": "Silakan masukkan kiriman",
    "religion": "Agama",
    "religionPlaceholder": "Silakan pilih agama",
    "retrievePassword": "Dapatkan kembali kata sandi",
    "setUp": "Pengaturan",
    "signOut": "Keluar",
    "something": "Saya ingin mengatakan",
    "submit": "Kirimkan",
    "sureDelte": "Silakan pastikan Anda ingin menghapusnya?",
    "teacher": "Dosen",
    "learnYet": "Belum mulai belajar",
    "uName": "Nama pengguna",
    "uNamePlaceholder": "Nama pengguna",
    "userCenter": "Informasi pribadi",
    "username": "Nama pengguna",
    "validateMsg": "Verifikasi Gagal",
    "woman": "Perempuan",
    "learnTo": "Kemajuan",
    "myRecord": "Rekor saya",
    "plePhone": "Silahkan masukkan nomor telepon"
  },
  "notice_zlb": {
    "delete": "Hapus",
    "home": "Beranda",
    "lettre": "Pesan pribadi",
    "lettreEmpty": "Pesan pribadi tidak boleh kosong",
    "messageDetail": "Perincian Pesan",
    "myMessage": "Pesan saya",
    "notice": "Pemberitahuan",
    "nowBavarder": "Sekarang Anda bisa mulai mengobrol",
    "send": "Kirim"
  },
  "play_zlb": {
    "networkTip": "Pemberitahuan jaringan",
    "streamHighTip": "Koneksi jaringan saat ini stabil. Kami telah mengalihkan ke mode definisi tinggi untuk Anda.",
    "streamHighType": "HD",
    "streamNormTip": "Koneksi jaringan saat ini tidak stabil. Kami telah mengalihkan ke mode standar untuk Anda.",
    "streamNormType": "SD",
    "liveTimeDes": "Waktu siaran langsung",
    "livePlayWait": "Siarang langsung belum dimulai",
    "livePlayEnd": "Siaran langsung berakhir"
  },
  "questionnaire_zlb": {
    "handed": "Kirimkan",
    "saveFailed": "Gagal menyimpan",
    "examList": "Daftar pertanyaan tes"
  },
  "research_zlb": {
    "afternoon": "PM",
    "all": "Semua",
    "allCalendar": "Semua Agenda",
    "alumniBook": "Anggota",
    "broadcast": "x mulai siaran",
    "carriedout": "Sedang Berlangsung",
    "certificate": "Sertifikat",
    "comment": "Komentar",
    "comments": "Semua x komentar",
    "courses": "Referensi",
    "curDis": "Sedang berlangsung",
    "default": "Belum dimulai",
    "delete": "Hapus",
    "detail": "Perincian",
    "discuss": "Forum",
    "end": "Berakhir",
    "endAssess": "Evaluasi Berakhir",
    "enterAssess": "Mulai Evaluasi",
    "assessButton": "Umpan Balik",
    "evaluation": "Evaluasi",
    "fileAcept": "Jenis file salah, silakan unggah lagi.",
    "fileSize10": "File yang dipilih melebihi 10m, silakan unggah lagi.",
    "hisDis": "Riwayat",
    "lecture": "Referensi",
    "live": "Langsung",
    "livebroadcast": "Siaran langsung",
    "minutes": "x menit lalu",
    "month": "Bulan",
    "morning": "AM",
    "noDiscussion": "Tidak Ada Lokakarya",
    "noSchedule": "Tidak Ada Agenda",
    "notice": "Pemberitahuan",
    "notification": "Pemberitahuan belum dibaca",
    "offline": "Kuliah tatap muka",
    "onging": "Sedang Berlangsung",
    "online": "Daring",
    "operation": "Penugasan",
    "over": "Berakhir",
    "participated": "Sudah Berpartisipasi ",
    "notParticipate": "Belum Berpartisipasi ",
    "failedCourse": "Tidak Lulus",
    "passedCourse": "Lulus",
    "preparation": "Persiapan tugas",
    "preparations": "Persiapan tugas",
    "preschoolLecture": "Kuliah pemanasan",
    "questionnaire": "Kuesioner",
    "questionType ": "pilihan ganda (hanya satu jawaban yang benar; tandai semua jawaban yang benar)",
    "readySay": "Saya ingin mengatakan",
    "replies": "Anda memiliki x balasan baru",
    "save": "Simpan",
    "schedule": "Agenda",
    "searchC": "Telusuri topik yang Anda minati",
    "seeAssess": "Lihat Evaluasi",
    "submit": "Kirimkan",
    "submitHomewor": "Batal",
    "task": "Tugas",
    "taskToday": "Tugas untuk hari ini",
    "video": "Video",
    "week": "Pekan",
    "yourcomment": "Tuliskan komentar Anda",
    "legend": "Legenda",
    "sunday": "Minggu",
    "monday": "Senin",
    "tuesday": "Selasa",
    "wednesday": "Rabu",
    "thursday": "Kamis",
    "friday": "Jumat",
    "saturday": "Sabtu",
    "consult": "Bahan Referensi",
    "schedules": "Tugas",
    "calendar": "Kalender",
    "waitAssesment": "Kuesioner yang akan dikirimkan",
    "year": "Tahun",
    "day": "Hari",
    "preview": "Pratinjau",
    "resource": "Unduh"
  },
  "retrieve_zlb": {
    "emailEmpty": "Alamat email tak boleh kosong",
    "emailVerif": "Verifikasi email"
  },
  "task_zlb": {
    "downF": "Unduh Lampiran",
    "repeatUp": "Unggah ulang",
    "ruY": "Jika satu lampiran telah diunggah di aplikasi, itu akan ditimpa jika Anda mengunggah yang lain di PC.",
    "submitC": "Silakan masukkan apa yang Anda ingin kirimkan",
    "uploadF": "Unggah Lampiran"
  },
  "upload_zlb": {
    "clickHere": "klik di sini",
    "limit": "Format file mendukung PNG, ukuran JPG tidak boleh melebihi",
    "preview": "Pratinjau setelah mengunggah gambar",
    "upload": "Unggah"
  },
  "index": {
    "setAsHomePage": "Tetapkan sebagai halaman beranda",
    "addCollection": "Tambahkan ke favorit",
    "telephone": "Saluran siaga",
    "Help": "Pusat Bantuan",
    "SystemMessage": "Pemberitahuan sistem",
    "message": "Pesan pribadi",
    "emptyMessage": "Hapus",
    "checkAllMessage": "Lihat Semua",
    "noMessage": "Tidak ada data",
    "fullScreen": "Tampilan layar penuh",
    "ExitSystem": "Keluar dari sistem ini",
    "back": "Kembali",
    "top": "Atas",
    "backToTop": "Kembali ke atas",
    "homePage": "Beranda",
    "favoriteTips": "Karena batasan peramban 360  / peramban Google, silakan tekan Ctrl + D untuk mengumpulkan secara manual!",
    "autoSetHomeTips": "Peramban Anda tidak mendukung pengaturan otomatis halaman beranda, gunakan menu beranda untuk mengaturnya secara manual!",
    "currentUser": "Pengguna Saat Ini",
    "userHead": "Foto Profil",
    "accountPassword": "Kata Sandi Akun",
    "change": "Perbarui",
    "head": "Foto Profil",
    "continueStudy": "Lanjutkan",
    "startStudy": "Mulai Belajar"
  },
  "course": {
    "count": "umumnya",
    "item": "Artikel",
    "up": "Halaman sebelumnya",
    "next": "Halaman berikutnya",
    "items": "per halaman",
    "go": "Menuju ke",
    "page": "Halaman",
    "man": "Pengguna",
    "score": "Skor",
    "courseYear": "Tahun",
    "courseTeachers": "Dosen",
    "noDesc": "Tidak ada perkenalan",
    "teachersDesc": "Profil guru",
    "checkLog": "Lihat catatan",
    "startStudy": "Mulai Belajar",
    "JoinLearning": "Gabung",
    "isEvaluate": "Dievaluasi",
    "deleteNoteButton": "Hapus",
    "closeButton": "Tutup",
    "noteSource": "Dari"
  },
  "onlineclass": {
    "myScore": "Skor saya",
    "comments": "Komentar",
    "iknow": "Saya tahu",
    "detail": "Perincian",
    "inforCertificate": "Sertifikat",
    "wantTalk": "Saya ingin memberi komentar",
    "inputTalkContent": "Silakan masukkan komentar",
    "publish": "Lepaskan",
    "undo": "Batal",
    "reply": "Balas",
    "delete": "Hapus",
    "Learned": "Selesai",
    "isDelete": "Anda yakin ingin menghapusnya?",
    "submitTime": "Waktu pengiriman",
    "to": "sampai",
    "download": "Unduh"
  },
  "usercenter": {
    "htllo": "Halo",
    "welcomeMessage": "Semoga hari Anda menyenangkan",
    "searchTips": "Cari kursus yang Anda suka",
    "myCertificate": "Sertifikat Saya",
    "startQuestionnaire": "Mulailah menjawab kertasnya",
    "empty": "tidak ada",
    "confirmDelete": "Konfirmasi penghapusan",
    "confirmDeleteTips": "Anda yakin ingin menghapusnya?",
    "delete": "Hapus",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Akhiri pembelajaran",
    "tips": "Tips",
    "playTips": "Tips: Silakan klik tombol \"Akhiri Pembelajaran\" di pojok kanan atas untuk keluar. Jika Anda berhenti belajar dengan menutup peramban, waktu belajar Anda mungkin tidak dicatat dengan benar.",
    "notShowAgain": "Jangan ingatkan saya lagi",
    "gotIt": "Saya tahu",
    "chapter": "Bab",
    "language": "Bahasa",
    "chapterText1": "No.",
    "chapterText2": "Bab",
    "note": "Catatan",
    "noteBlockTitle": "Catatan",
    "evaluate": "Evaluasi",
    "evaluateStar": "Bintang",
    "saveEvaluate": "Kirimkan",
    "notePlaceholder": "Silakan ambil catatan",
    "closeTips": "Perubahan yang Anda buat tidak akan disimpan",
    "closeButton": "Tinggalkan",
    "autoStop": "Otomatis berhenti bermain",
    "autoStopTips": "Waktu tunggu ketidakaktifan pengguna. Pemutaran berhenti secara otomatis.",
    "confirmOut": "Anda yakin ingin berhenti bermain?",
    "closeOrNot": "Tutup jendela saat ini",
    "noCoursePlay": "Tidak ditemukan sumber yang dapat diputar di kursus ini",
    "attention": "Mohon perhatian!"
  },
  "assessment_zlb": {
    "score": "Skor",
    "evalSuccess": "Evaluasi berhasil"
  },
  "undefined": {}
};